import React from "react";
import styled, { css } from "styled-components";
const Title = styled.h3(
  ({ theme }) => css`
    a {
      color: ${theme.colors.text.primary};
    }

    .label {
      font-size: ${theme.fonts.size.tiny};
      line-height: 200%;
      margin-left: 5px;
      vertical-align: bottom;
    }
  `
);
const MessageDetailsTitle = ({ children = void 0 }) => /* @__PURE__ */ React.createElement(Title, null, children);
export default MessageDetailsTitle;
